<template>
<p class="text-sm leading-normal">
  Если у вас возникли затруднения,<br v-if="condensed">
  вы можете
  <a href="javascript:;" class="text-primary hover:underline hover:text-primary-light" @click="truncateOrder">
    очистить корзину
  </a>
</p>
</template>

<script>
import storage from '@/storage'

export default {
  props: {
    condensed: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  methods: {
    truncateOrder() {
      if (!confirm('Вы уверены, что хотите очистить корзину?')) {
        return
      }

      storage.activeOrderId(null, true)
      storage.activeOrderToken(null, true)
      storage.deliveryMethod(null, true)

      location.reload()
    },
  },
}
</script>
